import { Square2StackIcon } from "@heroicons/react/24/outline";

export const SectionSubHeader = (props) => {

  // input
  const {
    title = null,
    Icon = Square2StackIcon
  } = props;

  return (
    <div className="flex flex-row justify-start items-center">
      {Icon && <Icon className="h-8 w-8 text-primary-500" />}
      <h2 className="pl-2 text-lg text-slate-700 font-semibold">{title}</h2>
    </div>
  );
};
